export const removeBadSkills = <
  T extends { id?: unknown; short_name?: string },
>(
  skillRefs: T[] | undefined = []
): T[] => {
  return (skillRefs ?? []).filter(
    (skillRef) =>
      skillRef.id === undefined ||
      skillRef.id === null ||
      skillRef.short_name !== 'unknown'
  ) as T[];
};
